<template>
  <vs-prompt
    class="dialog-input-reason-risk-level-input"
    @accept="() => handleAccept(riskLevel, { byPicture, byRoute, reason })"
    @cancel="handleCancel"
    @close="handleClose"
    :color="color"
    :active="active"
    :title="title"
    :accept-text="acceptText"
    :cancel-text="cancelText"
    :is-valid="isValid"
  >
    <div class="dialog-input-reason-risk-level-input-form flex flex-col">
      <div class="dialog-input-reason-basic flex flex-col">
        <span class="input-label">
          <span class="font-semibold">「{{ riskLevelLabel }}」</span
          >と判断した情報を選択してください（必須）</span
        >
        <vs-checkbox class="aisea-ml-3" color="#48a0f4" v-model="byPicture">
          画像情報
        </vs-checkbox>
        <vs-checkbox class="aisea-ml-3" color="#48a0f4" v-model="byRoute">
          航跡情報
        </vs-checkbox>
      </div>
      <div class="dialog-input-reason-others flex flex-col">
        <span class="input-label">メモ</span>
        <div>
          <vs-textarea
            class="dialog-input-reason-others-textarea m-0"
            placeholder="その他の理由(40文字以内)"
            v-model="reason"
          ></vs-textarea>
          <div
            v-show="!isValidReason"
            class="dialog-input-reason-others-validation con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
            style="height: 21px"
          >
            <span class="span-text-validation">
              その他の理由は40文字以内で入力してください
            </span>
          </div>
        </div>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import isString from "lodash/isString";
import { RadarGridMixin } from "@/mixins";

export default {
  name: "DialogInputReasonRiskLevel",
  mixins: [RadarGridMixin],
  props: {
    title: { type: String, default: "危険判定の理由" },
    acceptText: { type: String, default: "送信" },
    cancelText: { type: String, default: "キャンセル" },
    color: { type: String, default: "#2D9CDB" },

    radarDetectedObjectId: { Type: String, require: true },
    riskLevel: { Type: Number, require: true },
    handleCancel: { Type: Function, require: false },
    handleClose: { Type: Function, require: false },
    handleAccept: { Type: Function, require: false },
    active: { Type: Boolean, default: false },
  },
  data() {
    return {
      byPicture: false,
      byRoute: false,
      reason: "",
    };
  },
  computed: {
    riskLevelLabel() {
      return this.RADAR_GRID_OBJECT_RISK_LEVEL[this.riskLevel].labelJa;
    },
    isValid() {
      return this.isValidEvidence && this.isValidReason;
    },
    isValidEvidence() {
      return this.byPicture || this.byRoute;
    },
    isValidReason() {
      return isString(this.reason) && this.reason.length <= 40;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.dialog-input-reason-risk-level-input {
  &.con-vs-dialog {
    .vs-dialog {
      max-width: 370px;
    }
    .dialog-input-reason-risk-level-input-form {
      row-gap: 16px;
      .dialog-input-reason-basic {
        row-gap: 16px;
        font-family: $aisea-font-family;
        color: #757575;
      }

      .dialog-input-reason-others {
        row-gap: 6px;
        .dialog-input-reason-others-textarea {
          ::placeholder {
            font-family: $aisea-font-family;
            color: $aisea-mouse-gray;
          }
        }
      }
      .input-label {
        font-family: $aisea-font-family;
        font-size: 14px;
        line-height: 21px;
        color: #757575;
      }
    }
    .vs-dialog footer {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
    }
  }
}
</style>
